module.exports = __webpack_public_path__ + "r-v3/img/ml_05_01.32a83ca1.jpg";